﻿class VisibleWatcher {
    constructor() {
        this.elements = Array.from(document.querySelectorAll('.animate-in'));
        this.onScrollEventListener = this.checkElementPositions.bind(this);
        this.onResizeEventListener = this.calculateTriggerHeight.bind(this);

        if (this.elements.length > 0) {
            //console.log(this.elements);
            this.elements.forEach(element => {
                element.classList.add('animate-in--active');
            });
            this.calculateTriggerHeight();
            window.addEventListener('scroll', this.onScrollEventListener);
            window.addEventListener('resize', this.onResizeEventListener);
        }

        this.checkElementPositions();
    }


    //checks positions of elements in view when scrolling
    checkElementPositions() {
        for (var i = this.elements.length - 1; i >= 0; i--) {
            var element = this.elements[i];
            var elementRect = element.getBoundingClientRect();

            if ((elementRect.top + this.triggerHeight) < window.innerHeight && elementRect.bottom >= 0) {
                element.classList.add('animate-in--visible');
                this.elements.splice(i, 1); //remove element when class is added
            }
        }

        //of we have no more elements, stop and remove event handlers
        if (this.elements.length == 0) {
            this.done();
        }
    }

    //calculates how much of the element must be visible for it to be triggered
    calculateTriggerHeight() {
        this.triggerHeight = window.innerHeight * 0.2;
    }

    //removes all event handlers, when all elements are visible
    done() {
        window.removeEventListener('scroll', this.onScrollEventListener);
        window.removeEventListener('resize', this.onResizeEventListener);
    }
}


window.addEventListener('DOMContentLoaded', (e) => {
    new VisibleWatcher();
});